module.exports = __webpack_public_path__ + "document-icon.svg?86b737713185b30a5b430a18720950be";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/document-icon.svg
// module id = 3
// module chunks = 0